/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 15:09:29
 * @LastEditors: Chenhw2017 1272617071@qq.com
 * @LastEditTime: 2024-06-17 14:28:05
 */
import ColumnTypes from '@/utils/ColumnTypes';
import { drRoleType, zsRoleType } from '@/utils/dataMap';
import auth from '@/plugins/auth';
const drName = drRoleType.name;
export const getColumns = that => {
	const shopDetails = {
		key: 'shopDetails',
		label: '商品信息',
		type: ColumnTypes.MixinCell,
		minWidth: '320',
		fixed: 'left',
		source: 'order',
		isShow: auth.hasPermi('system:Order-Base-field'),
	};
	const anchor_name = {
		key: 'anchor_name',
		label: '推广者',
		type: ColumnTypes.DeliveryCell,
		minWidth: '280',
		isShow: auth.hasPermi('system:Order-spreader'),
	};
	const partner_name = {
		key: 'partner_name',
		label: drName,
		type: ColumnTypes.TextCell,
		minWidth: '100',
	};
	const LeaderInformation = {
		label: '团长信息',
		type: () => import('./components/tableCell/commandCell.vue'),
		minWidth: '200',
		isShow: auth.hasPermi('system:Leader-information'),
	};
	const activityInfo = {
		label: '活动信息',
		type: () => import('./components/tableCell/activityCell.vue'),
		minWidth: '200',
		isShow: auth.hasPermi('system:activity-information') && !that.$isSp(that.platformId),
	};

	const zs_belong = {
		label: '招商运营归属类型',
		type: () => import('./components/tableCell/belongCell.vue'),
		minWidth: '220',
		isShow: true,
		transform: row => {
			return {
				...row,
				belong_text: row.bd_belong_text,
				belong_time: row.bd_belong_time_text,
			};
		},
	};

	const dr_belong = {
		label: '达人商务归属类型',
		type: () => import('./components/tableCell/belongCell.vue'),
		minWidth: '220',
		isShow: true,
		transform: row => {
			return {
				...row,
				belong_text: row.talent_belong_text,
				belong_time: row.talent_belong_time_text,
			};
		},
	};
	const partner_performance = {
		key: 'partner_performance',
		label: `${drName}业绩`,
		type: ColumnTypes.PartnerPerformCell,
		minWidth: '180',
		noZs: true,
		isShow: auth.hasPermi('system:Order:Master-business-performance'),
	};
	const zsInfo = {
		key: 'bd_partner_name',
		label: zsRoleType.name,
		type: ColumnTypes.PartnerPerformZsCell,
		minWidth: '180',
		noDr: true,
		isShow: auth.hasPermi('system:Order:Investment-operation'),
	};
	const serve0 = {
		label: '服务费收入',
		noDr: true,
		noZs: true,
		type: ColumnTypes.serviceIncomeCell,
		minWidth: '180',
		isShow: auth.hasPermi('system:Order:Service-fee-income'),
	};
	const total_pay_amount = {
		key: 'total_pay_amount',
		label: '订单金额',
		inputType: 'Price',
		type: ColumnTypes.TextCell,
		minWidth: '100',
		isShow: auth.hasPermi('system:Order-Base-field'),
	};
	const serve1 = {
		label: '服务费支出',
		noDr: true,
		noZs: true,
		type: ColumnTypes.serviceDisburseCell,
		minWidth: '180',
		isShow: auth.hasPermi('system:Order:Service-fee-disburse') && !that.$isSp(that.platformId),
	};
	const serve3 = {
		label: '到手服务费',
		noDr: true,
		noZs: true,
		type: ColumnTypes.serverInhandCell,
		minWidth: '150',
		isShow: auth.hasPermi('system:Order-service-charge') && !that.$isSp(that.platformId),
	};
	const serve2 = {
		label: '技术服务费',
		noDr: true,
		noZs: true,
		type: ColumnTypes.serverCell,
		minWidth: '150',
		isShow: auth.hasPermi('system:Order:Technical-Service-fee') && !that.$isSp(that.platformId),
	};
	const order_status_desc = {
		key: 'order_status_desc',
		label: '订单状态',
		type: ColumnTypes.TextCell,
		minWidth: '100',
		isShow: auth.hasPermi('system:Order-Base-field'),
	};
	const orderTime = {
		key: 'orderTime',
		label: '订单时间',
		type: ColumnTypes.orderTimeCell,
		minWidth: '220',
		fixed: 'right',
		isShow: auth.hasPermi('system:Order-Base-field'),
	};
	return [
		shopDetails,
		anchor_name,
		partner_name,
		partner_performance,
		zsInfo,
		serve0,
		total_pay_amount,
		serve1,
		serve3,
		serve2,
		LeaderInformation,
		activityInfo,
		dr_belong,
		zs_belong,
		order_status_desc,
		orderTime,
	];
};
